import { render } from "./2StrukturOrganisasi.vue?vue&type=template&id=75a3155d"
import script from "./2StrukturOrganisasi.vue?vue&type=script&lang=js"
export * from "./2StrukturOrganisasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__